export const types = {
    IF: 'IF',
    ELSEIF: 'ELSEIF'
};